module.exports = __webpack_public_path__ + "static/jonWaiLing-db4c41c1cd7425fb1bfc2a86344ef8cc.jpg";